import styled from 'styled-components';

import StyledText from '../shared/StyledText';
import { MEDIUM_TEXT } from '../../constants';

const Container = styled.div`
  height: 330px;
`;

const CardPlaceholder = (
  <Container>
    <StyledText size={MEDIUM_TEXT} isBold>
      Hra se nepovedla načíst
    </StyledText>
  </Container>
);

export default CardPlaceholder;



// WEBPACK FOOTER //
// components/GameCards/CardPlaceholder.js